export const tailMisc = {
  tabBottom: {
    checkins: `Check-ins`,
    checkinsProg: `Check-ins Prog.`,
    requests: `Peticiones`,
  },
  adminNav: {
    myAccount: `Mi cuenta`,
  },
  loader: {
    title: `¡Creando {reason}!`,
    defaultReason: `alojamiento`,
    preparing: `Estamos preparando tu {reason}, por favor espera…`,
    calendar: `Configurando el calendario`,
    availability: `Verificando disponibilidad`,
    prices: `Configurando precios`,
    almostDone: `Casi listo, finalizando tu {reason}…`,
  },
};
